var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1393_2965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.614 21.7388H17.8554V15.9106C17.8554 14.5208 17.8303 12.7317 15.9005 12.7317C13.9429 12.7317 13.6434 14.2459 13.6434 15.8094V21.7384H9.88474V9.75329H13.493V11.3912H13.5435C13.9046 10.7798 14.4264 10.2769 15.0534 9.93601C15.6803 9.59508 16.3889 9.42891 17.1036 9.45518C20.9132 9.45518 21.6155 11.9362 21.6155 15.1639L21.614 21.7388ZM5.64378 8.11502C5.21239 8.11509 4.79065 7.9885 4.43191 7.75126C4.07318 7.51401 3.79357 7.17676 3.62842 6.78216C3.46326 6.38756 3.41997 5.95333 3.50406 5.53438C3.58814 5.11542 3.79582 4.73057 4.1008 4.42847C4.40579 4.12638 4.7944 3.92062 5.21749 3.83722C5.64058 3.75381 6.07914 3.7965 6.47773 3.95989C6.87632 4.12328 7.21701 4.40003 7.45675 4.75515C7.69648 5.11026 7.82449 5.5278 7.82457 5.95494C7.82462 6.23856 7.76824 6.5194 7.65868 6.78145C7.54911 7.04349 7.3885 7.2816 7.186 7.48218C6.9835 7.68276 6.74306 7.84189 6.47845 7.95047C6.21383 8.05905 5.93022 8.11496 5.64378 8.11502ZM7.52309 21.7388H3.76056V9.75329H7.52309V21.7388ZM23.4878 0.339602H1.87187C1.38125 0.33412 0.908478 0.521725 0.557484 0.861193C0.20649 1.20066 0.00598776 1.66422 0 2.15V23.6418C0.00578282 24.1278 0.206168 24.5917 0.55715 24.9315C0.908132 25.2713 1.38101 25.4593 1.87187 25.4541H23.4878C23.9796 25.4603 24.4538 25.2728 24.8062 24.933C25.1586 24.5932 25.3603 24.1288 25.3671 23.6418V2.14845C25.3601 1.6617 25.1582 1.19762 24.8058 0.85816C24.4535 0.518701 23.9794 0.331631 23.4878 0.338051",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1393_2965"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 25.3247,
    fill: "white",
    transform: "translate(0 0.337891)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.60bf9dbfde385ae1331b4ed1df4799a1.svg";
export { ForwardRef as ReactComponent };